type ChunkRecoveryContext = {
  isDevDeploy: boolean
  pageAlreadyRendered: boolean
  navigationInFlight: boolean
  isOnline: boolean
  loadedByReload: boolean
}

export function shouldReloadOnChunkError({
  isDevDeploy,
  pageAlreadyRendered,
  navigationInFlight,
  isOnline,
  loadedByReload,
}: ChunkRecoveryContext) {
  return (
    !isDevDeploy &&
    pageAlreadyRendered &&
    navigationInFlight &&
    isOnline &&
    !loadedByReload
  )
}
